import { LOGGED_IN_COOKIE } from './constants';

export const getCookie = (name) => {
  const decodedCookie = decodeURIComponent(document.cookie);
  const allCookies = decodedCookie.split(';');
  const matchingCookie = allCookies.find((cookie) => {
    const cookieName = cookie.trim().split('=')[0];
    return cookieName === name;
  });

  return matchingCookie ? matchingCookie.split('=')[1] : null;
};

export const isUserAuthenticated = () => {
  const cookie = getCookie(LOGGED_IN_COOKIE);

  return cookie === '1';
};

export function formatNumberWithIntl(number) {
  const formatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 1,
  });

  if (number >= 1e9) {
    return `${formatter.format(number / 1e9)}B`;
  }

  if (number >= 1e6) {
    return `${formatter.format(number / 1e6)}M`;
  }

  if (number >= 1000) {
    return `${formatter.format(number / 1000)}k`;
  }

  return formatter.format(number);
}

export function getPercentChange(previous, current) {
  if (!previous) {
    return '∞';
  }

  const roundedValue = (((current - previous) / previous) * 100).toFixed(1);
  const isChanged = current - previous !== 0;
  const isNegative = roundedValue < 0;
  const sign = roundedValue > 0 ? '↑' : '↓';

  return isChanged
    ? `${!isChanged ? '' : sign}${
        isNegative ? roundedValue.slice(1) : roundedValue
      }%`
    : '0%';
}

export const getRandomArbitrary = (min, max) => {
  return Math.random() * (max - min) + min;
};

export const setCookie = (name, value, maxAgeSeconds = 60 * 60 * 24 * 365) => {
  if (!name) {
    return;
  }
  document.cookie = `${name}=${value};max-age=${maxAgeSeconds}`;
};

export const getLocalStorage = (key, defaultValue) => {
  const item = localStorage.getItem(key);
  if (item === null) {
    return defaultValue;
  }
  return item;
};

export function debounce(callback, delay) {
  let timer;

  return (...args) => {
    return new Promise((resolve, reject) => {
      if (!timer) {
        try {
          const output = callback(...args);
          resolve(output);
        } catch (err) {
          reject(err);
        }
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        try {
          const output = callback(...args);
          timer = null;
          resolve(output);
        } catch (err) {
          timer = null;
          reject(err);
        }
      }, delay);
    });
  };
}

export function trackEvent(eventName, eventParams) {
  window.gtag('event', eventName, eventParams);
}

const subdomain = window.location.hostname.split('.')[0];
const isLocalhost = subdomain === 'localhost';

export const isEnv = {
  development: isLocalhost,
  staging: subdomain === 'links-staging' || subdomain === 'creators-staging',
  production: subdomain === 'links' || subdomain === 'creators',
};
